/* eslint-disable sort-imports */

import Vue from "vue"
import ElementUI from "element-ui"

import "@/styles/overrides/element-ui-plugin-base.scss"

import ElementLocale from "element-ui/lib/locale"
import fr from "element-ui/lib/locale/lang/fr"
ElementLocale.use(fr)

Vue.use(ElementUI)
